// src/services/AuthService.js
import fetch from 'auth/FetchInterceptor';

const AuthService = {};

AuthService.login = function (data) {
	return fetch({
		url: '/v1/auth/login',
		method: 'post',
		data,
	});
};

AuthService.logout = function () {
	return fetch({
		url: '/v1/auth/logout',
		method: 'post',
	});
};

AuthService.me = function () {
	return fetch({
		url: '/v1/auth/me',
		method: 'get',
	});
};

export default AuthService;